import { createFloaterMenuDriver } from '../..';
import { compKey } from './key';
export var createPopoverSelectDriver = function (wrapper, global) {
    var base = wrapper.$("." + compKey);
    var baseWithTitle = wrapper.$(".popover-select-title-wrapper");
    var floaterMenuDriver = createFloaterMenuDriver(global);
    return {
        getSelectedOption: base.$('.selected-option-title').text,
        getValueText: base.$('.inner-popover-select').text,
        openPopoverMenu: base.click,
        getOptions: floaterMenuDriver.getItems,
        getTitle: baseWithTitle.$('.popover-select-title').text,
        isPopoverMenuOpen: floaterMenuDriver.base.exists,
        selectOption: floaterMenuDriver.selectByValue,
        isDisabled: base.$('.inner-popover-select.disabled').exists,
        isBorderDisplayed: function () { return base.hasClass('left-border'); },
        menuDividerPosition: function (idx) {
            return global.$('.menu-item-divider').hasClass("menu-divider-item-" + idx);
        },
        getMenuSubtitle: function (idx) { return floaterMenuDriver.getSubtitle(idx); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map